// ========= START: src/components/UsernameSetupScreen.js (New File) =========
import React, { useState } from 'react';

function UsernameSetupScreen({ onSave }) {
  const [username, setUsername] = useState('');

  const handleSave = () => {
    // Basic validation to ensure the username is not empty
    if (username.trim()) {
      onSave(username.trim());
    } else {
      alert('Please enter a username.');
    }
  };

  return (
    <div className="username-setup-screen">
      <div className="username-setup-panel">
        <h2 className="username-setup-title">Welcome!</h2>
        <p className="username-setup-text">Please enter your name to begin:</p>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Your Name"
          className="username-input"
          maxLength="12"
        />
        <button onClick={handleSave} className="username-save-button">
          Save and Start
        </button>
      </div>
    </div>
  );
}

export default UsernameSetupScreen;
// ========= END: src/components/UsernameSetupScreen.js (New File) =========